import { Box, Typography } from "@mui/material";
import { Configuration } from "Infrastructure/Config/config";

export const TestEnv = () => {
  const isDevelopment = Configuration.getIsDevelopment();

  if (!isDevelopment) return null;

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "red", textAlign: "center" }}>
      <Typography variant="body2" color="white">
        Pozor, jste na testovacím prostředí!
      </Typography>
    </Box>
  );
};
